"use strict";

exports.__esModule = true;
exports.OpenDashboardUserAction = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _OpenDashboardActionElement = require("./OpenDashboardActionElement");
var _OpenDashboardActionFields = require("./OpenDashboardActionFields");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var OpenDashboardUserAction = exports.OpenDashboardUserAction = {
  name: "OpenDashboard",
  icon: "link",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "OpenDashboardUserActionDefinition.label",
    defaultMessage: "Open Dashboard"
  }),
  description: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "OpenDashboardUserActionDefinition.description",
    defaultMessage: "Opens the dashboard page for selected dashboard"
  }),
  requiresContexts: [],
  requiresProps: ["dashboardID"],
  components: {
    Element: _OpenDashboardActionElement.OpenDashboardActionElement,
    Fields: _OpenDashboardActionFields.OpenDashboardActionFields
  }
};